
import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client";
import { SetContextLink } from "@apollo/client/link/context"; 
import { getCmsToken } from "./cmsTokenClient";

const GRAPHQL_URL = `${process.env.REACT_APP_CMS_BASE_URL}/api/graphql`;

const authLink = new SetContextLink(async (_, { headers = {} }) => {
  try {
    const token = await getCmsToken();
   // console.log("TOKEN USED FOR GRAPHQL:", token)

    return {
      headers: {
        ...headers,
        ...(token && { Authorization: `Bearer ${token}` }), 
        "Content-Type": "application/json",
      },
    };
  } catch (err) {
    console.error("Token fetch failed:", err);
    return { headers };
  }
});

const httpLink = new HttpLink({
  uri: GRAPHQL_URL,
});

export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});
